const styles = (theme) => ({
    appbarLink: {
        // margin: '10px 10px',
        // padding: '10px 10px',
        '&:hover':{
            // backgroundColor: 'rgba(200,200,200,1)'
        },
        textDecoration: 'none'
    },
    linkText: {
        textDecoration: 'none'
    }
});

export default styles;